import Vue from 'vue'
import VueMask from 'v-mask'
import router from './router'
import { auth } from './db.js'
import Vuelidate from 'vuelidate'
import store from './store/index'
import App from './components/App'
import parser from './plugins/parser'
import BootrsapVue from 'bootstrap-vue'
import { firestorePlugin } from 'vuefire'
import Icon from 'vue-awesome/components/Icon'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'vue-awesome/icons'
import VueApexCharts from 'vue-apexcharts'
import JsonCSV from 'vue-json-csv'
import movable from "v-movable";
import VModal from 'vue-js-modal';
import '../public/css/main.css';
// import VueRecord from '@codekraft-studio/vue-record'
// import AudioRecorder from 'vue-audio-recorder'
import UUID from "vue-uuid";
import { XlsxRead, XlsxJson } from "vue-xlsx/dist/vue-xlsx.es.js"

Vue.use(parser)
Vue.use(VueMask)
Vue.use(Vuelidate)
Vue.use(BootrsapVue)
Vue.use(firestorePlugin)
Vue.use(VueApexCharts)
Vue.use(movable);
Vue.use(VModal);
Vue.use(UUID);
// Vue.use(VueRecord);
// Vue.use(AudioRecorder)

Vue.use(XlsxRead);
Vue.use(XlsxJson);

Vue.component('v-icon', Icon)
Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)

document.addEventListener("visibilitychange", () => {
	if (document.visibilityState == 'visible') { document.querySelector( "link[rel='shortcut icon']").href = "/favicon.png"; }
}, false);

Vue.directive('focus', {
	inserted(el) {
		el.focus();
	}
})

function getQueryParams(url) {
	const params = {};
	const queryString = url.split('?')[1];
	if (queryString) {
	const keyValuePairs = queryString.split('&');
	keyValuePairs.forEach(pair => {
		const [key, value] = pair.split('=');
		params[key] = decodeURIComponent(value);
	});
	}
	return params;
}
function normalizePhoneNumber(phoneNumber) {
	const normalizedNumber = phoneNumber.replace(/\D/g, "");
	if (normalizedNumber.startsWith('1')) {
		return normalizedNumber.substring(1);
	}
	return normalizedNumber;
}
const currentURL = window.location.href;
if (currentURL.endsWith("/Login")) {
    store.state.firebase.extensionuuid = 0;
}
const queryParams = getQueryParams(currentURL);
if(queryParams.numberSelected){
//eslint-disable-next-line
console.log("Current URL:", normalizePhoneNumber(queryParams.numberSelected));
store.state.firebase.extensionuuid = normalizePhoneNumber(queryParams.numberSelected);
}

auth.onAuthStateChanged(() => {
	new Vue({
		store,
		router,
		render: h => h(App),
	}).$mount('#app')
})
